import { useState, useEffect } from 'react';

/**
 * Hook para reagir a media queries CSS (ex: breakpoints do Tailwind).
 * Retorna true/false conforme o match atual e atualiza em tempo real
 * quando a tela é redimensionada ou o dispositivo gira.
 *
 * Uso: const isMobile = useMediaQuery('(max-width: 767px)');
 */
export function useMediaQuery(query) {
  const getMatch = () => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia(query).matches;
  };

  const [matches, setMatches] = useState(getMatch);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;

    const mediaQueryList = window.matchMedia(query);
    const listener = (event) => setMatches(event.matches);

    // Garante o valor correto caso a query tenha mudado entre renders
    setMatches(mediaQueryList.matches);

    // addEventListener é suportado nos browsers modernos (Android/iOS recentes)
    if (mediaQueryList.addEventListener) {
      mediaQueryList.addEventListener('change', listener);
      return () => mediaQueryList.removeEventListener('change', listener);
    }

    // Fallback para navegadores antigos
    mediaQueryList.addListener(listener);
    return () => mediaQueryList.removeListener(listener);
  }, [query]);

  return matches;
}

// Breakpoint padrão do Tailwind (md) usado para diferenciar mobile x desktop
// no esqueleto da aplicação (sidebar, header, layout).
export function useIsMobile() {
  return useMediaQuery('(max-width: 767px)');
}

export default useMediaQuery;
